import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SetupStructureTerminalStore } from '../../../../../store';
import { TreeService, BusinessService, TabStructureService, UserHandlerService, BreadcrumbService, HttpService, NotificationService } from '../../../../../shared/services';
import { Router } from '@angular/router';

@Component({
	selector: 'app-setup-structure-terminals-list',
	templateUrl: './setup-structure-terminals-list.component.html',
	styleUrls: ['./setup-structure-terminals-list.component.scss']
})
export class SetupStructureTerminalsListComponent implements OnInit {
	public attributes: any[] = [];
	public storeValue: string = '';
	public storeObject: any = {};
	public action: any[] = [];
	public parameters: any = {
		// noGrid: true
		// xTypeTag: 'struct.chain'
	};
	fetchByStore: boolean = true;
	// public detailVisible: boolean = true;
	public terminalID: string = '';
	public transactionType: string = 'all';
	showDetails: boolean = false;
	setBizId: boolean = true;
	addBtn: boolean = false;
	tooltipMessage: string = 'Add Terminal';
	public viewDetails: any[] = [
		{ header: 'Active', mapTo: 'xStatus' },
		{ header: 'Store Name', mapTo: 'xStoreName' },
		{ header: 'ProfitCenter Name', mapTo: 'xPctrName'},
		{ header: 'Name', mapTo: 'xName' },
		{ header: 'GMID', mapTo: 'xGMID' },
		{ header: 'GTID', mapTo: 'xGTID' },
		{ header: 'GMPW', mapTo: 'xGMPW' },
		{ header: 'Serial Number', mapTo: 'xRegSerNum' },	
		{ header: 'TypeTag', mapTo: 'xTypeTag' },
		{ header: 'Tag', mapTo: 'xTag' },
		{ header: 'Notes', mapTo: 'xNotes' },
		{ header: 'User Name', mapTo: 'xUName' },
		{ header: 'ID', mapTo: '_id' }
		// { header: 'Main Phone', mapTo: 'xMainContact.xPhone' }
	];

	constructor(
		private router: Router,
		private setupStructureTerminalStore: SetupStructureTerminalStore,
		public treeService: TreeService,
		public businessService: BusinessService,
		private tabStructureService: TabStructureService,
		private userHandlerService: UserHandlerService,
		private breadcrumbService: BreadcrumbService,
		private httpService: HttpService,
		private notificationService: NotificationService,
		private http: HttpClient
	) {}

	ngOnInit() {
		this.setBreadCrumbValue();
		// this.urlStoreService.isForm=false;
		this.treeService.isParent = false;
		this.tabStructureService.checkAndSetTabNameToDef(
			this.tabStructureService.tabMode,
			this.tabStructureService.isCancelClick,
			this.tabStructureService.isSubmitClick
		);
		//For upward hierarchy-------->
		if (this.treeService.periphID.getValue()) {
			this.addBtn = false;
			this.tooltipMessage = 'Please select a merchant account to add terminal';
			this.setBizId = false;
			console.log(
				'%c this.treeService.treeDataUnderStore.xTerminalID hai ya nahi??',
				'background: pink; color: black',
				this.treeService.treeDataUnderStore.xTerminalID
			);
			if (this.treeService.treeDataUnderStore.xTerminalID) {
				console.log(
					'%c this.treeService.treeDataUnderStore.xTerminalID',
					'background: pink; color: black',
					this.treeService.treeDataUnderStore.xTerminalID
				);
				this.router.navigate(['/dashboard/setup/business/structure/terminal', this.treeService.treeDataUnderStore.xTerminalID]);
			}
		}
		//End of upward hierarchy-------->
		//For self------>
		if (this.treeService.terminalID.getValue()) {
			this.setBizId = false;
			this.treeService.isParent = true;
			this.router.navigate(['/dashboard/setup/business/structure/terminal', this.treeService.terminalID.getValue()]);
		}
		// End for self------->
		//For downward hierarchy------->
		if (this.treeService.businessID.getValue()) {
			this.addBtn = false;
			this.tooltipMessage = 'Please select a merchant account to add terminal';
			this.setBizId = false;
			console.log('here');
			// let tempObj = {
			//     business: "current",
			//     chain: "list",
			//     region: "list",
			//     property: "list",
			//     store: "list",
			//     pctr: "list",
			//     meracct: 'list',
			//     terminal: 'list',
			//     periph: 'list',
			// }
			// this.businessService.setTabStructureNames(tempObj);
		}
		if (this.treeService.chainID.getValue()) {
			this.addBtn = false;
			this.tooltipMessage = 'Please select a merchant account to add terminal';
			this.setBizId = false;
			this.parameters = {
				// xTypeTag: 'struct.property',
				struct_type: 'chain',
				structID: this.treeService.chainID.getValue()
			};
		}
		if (this.treeService.regionID.getValue()) {
			this.addBtn = false;
			this.tooltipMessage = 'Please select a merchant account to add terminal';
			this.setBizId = false;
			this.parameters = {
				// xTypeTag: 'struct.property',
				struct_type: 'region',
				structID: this.treeService.regionID.getValue()
			};
		}
		if (this.treeService.propertyID.getValue()) {
			this.setBizId = false;
			this.addBtn = false;
			this.tooltipMessage = 'Please select a merchant account to add terminal';
			this.parameters = {
				// xTypeTag: 'struct.property',
				struct_type: 'property',
				structID: this.treeService.propertyID.getValue()
			};
		}
		if (this.treeService.storeID.getValue()) {
			this.setBizId = false;
			this.addBtn = false;
			this.tooltipMessage = 'Please select a merchant account to add terminal';
			this.parameters = {
				// xTypeTag: 'struct.property',
				xStoreID: this.treeService.storeID.getValue()
			};
		}
		if (this.treeService.profitCenterID.getValue()) {
			this.setBizId = false;
			this.addBtn = false;
			this.tooltipMessage = 'Please select a merchant account to add terminal';
			this.parameters = {
				xMainPCtrID: this.treeService.profitCenterID.getValue()
			};
		}
		if (this.treeService.merchantAccID.getValue()) {
			this.setBizId = false;
			this.addBtn = true;
			this.tooltipMessage = 'Add Terminal';
			this.parameters = {
				xMainMerAcctID: this.treeService.merchantAccID.getValue()
			};
		} else {
			console.log("I'm fucking here");
			if (this.setBizId) {
				this.addBtn = false;
				this.tooltipMessage = 'Please select a merchant account to add terminal';
				this.treeService.setId(this.businessService.businessID.getValue(), 'business');
			}
		}
		//End of downward hierarchy----->
		this.parameters.grid = true;	

		this.setGridProperties();
	}

	setBreadCrumbValue(): void {
		const breadCrumb: any = {};
		breadCrumb.root = 'Setup';
		breadCrumb.child = 'Structure';
		breadCrumb.subChild = 'Terminal';
		breadCrumb.subChildLink = null;
		breadCrumb.grandChild = 'Terminals';
		breadCrumb.rootList = [];
		this.breadcrumbService.setBreadCrumb(breadCrumb);
	}

	setGridProperties() {
		this.storeValue = 'SetupStructureTerminalStore';
		this.storeObject = this.setupStructureTerminalStore;
		// this.attributes = [
		//     { header: 'Active', mapTo: 'xStatus', width: '10%' },
		//     { header: 'Name', mapTo: 'xName', width: '20%' },
		//     { header: 'TypeTag', mapTo: 'xTypeTag', width: '20%' },
		//     { header: 'Tag', mapTo: 'xTag', width: '20%' },
		//     // { header: 'Medium', mapTo: 'xMdmTag', width: '10%' },
		//     // { header: 'SoP', mapTo: 'xStrVal', width: '10%' },
		//     { header: 'Notes', mapTo: 'xNotes', width: '20%' },
		//     { header: 'Actions', mapTo: '', width: '10%'}
		// ];
		const editLink = '/dashboard/setup/business/structure/terminal';
		this.action = [
			{ type: 'view', visible: true, text: 'Details', icon: 'fa fa-eye', action: 'emit' },
			{ type: 'downloadBusinessInfo', visible: true, text: 'Download ccv_info.dat', icon: 'fa fa-download', action: 'emit' }
			// { type: 'edit', visible: true, text: 'Edit', icon: 'fa fa-edit', action: 'url', onClick: editLink },
			// { type: 'delete', visible: true, text: 'Delete', icon: 'fa fa-trash', action: 'func', onClick: 'destroy'}
		];
		if (!this.userHandlerService.userRoles.isBusinessEmployee) {
			this.attributes = [
				// { header: 'Active', mapTo: 'xStatus', width: '5%' },		
				{ header: 'Store Name', mapTo: 'xStoreName', width: '14%' },	
				{ header: 'Pctr Name', mapTo: 'xPctrName', width: '14%' },
				{ header: 'Name', mapTo: 'xName', width: '15%' },
				{ header: 'GMID', mapTo: 'xGMID', width: '10%' },
				{ header: 'GTID', mapTo: 'xGTID', width: '12%' },
				{ header: 'GMPW', mapTo: 'xGMPW', width: '15%' },
				{ header: 'Serial Num', mapTo: 'xRegSerNum', width: '10%' },				
				// { header: 'Tag', mapTo: 'xTag', width: '10%' },
				// { header: 'Type Tag', mapTo: 'xTypeTag', width: '10%' },
				// { header: 'Medium', mapTo: 'xMdmTag', width: '10%' },
				// { header: 'SoP', mapTo: 'xStrVal', width: '10%' },
				// { header: 'Notes', mapTo: 'xNotes', width: '10%' },
				{ header: 'Actions', mapTo: '', width: '10%' }
			];
			this.action.push(
				{
					type: 'edit',
					visible: true,
					text: 'Edit',
					icon: 'fa fa-edit',
					action: 'url',
					onClick: editLink
				},
				{
					type: 'delete',
					visible: true,
					text: 'Delete',
					icon: 'fa fa-trash',
					action: 'func',
					onClick: 'destroy',
					disabled: !this.userHandlerService.userPerms.canDeleteSetup
				}
			);
		} else if (this.userHandlerService.userRoles.isBusinessEmployee) {
			this.attributes = [
				// { header: 'Active', mapTo: 'xStatus', width: '5%' },
				{ header: 'Store Name', mapTo: 'xStoreName', width: '14%' },	
				{ header: 'ProfitCenter Name', mapTo: 'xPctrName', width: '14%' },
				{ header: 'Name', mapTo: 'xName', width: '15%' },
				{ header: 'GMID', mapTo: 'xGMID', width: '10%' },
				{ header: 'GTID', mapTo: 'xGTID', width: '12%' },
				{ header: 'GMPW', mapTo: 'xGMPW', width: '15%' },
				{ header: 'Serial Num', mapTo: 'xRegSerNum', width: '10%' },					
				// { header: 'Tag', mapTo: 'xTag', width: '10%' },
				// { header: 'Type Tag', mapTo: 'xTypeTag', width: '10%' },
				// { header: 'Medium', mapTo: 'xMdmTag', width: '10%' },
				// { header: 'SoP', mapTo: 'xStrVal', width: '10%' },
				// { header: 'Notes', mapTo: 'xNotes', width: '10%' }
			];
		}
	}

	onActionRequest(obj: any) {
		if (obj.act.type === 'view') {
			console.log("I'm here bro", obj);
			this.terminalID = obj.id;
			// this.detailVisible = true;
		}
		if (obj.act.type === 'downloadBusinessInfo') {
			this.downloadBusinessInfo(obj.data);
		}
	}

	downloadBusinessInfo(terminal: any) {
		if (!terminal || !terminal.xBusinessID) {
			this.notificationService.error('Business information not found for this terminal.', 'Error');
			return;
		}
		this.httpService.get('xbcBusinesses', terminal.xBusinessID).subscribe(
			(response: any) => {
				const business = response && response.data ? response.data : {};
				const addr = business.xAddr || {};
				const fileData = {
					businessName: business.xName || '',
					addrLine1: addr.xLine1 || '',
					addrLine2: addr.xLine2 || '',
					suite: addr.xSuite || '',
					city: addr.xCity || '',
					state: addr.xSOP || '',
					zip: addr.xPostCode != null ? String(addr.xPostCode) : '',
					email: business.xMainContact && business.xMainContact.xEmail ? business.xMainContact.xEmail : '',
					phone: business.xMainContact && business.xMainContact.xPhone ? business.xMainContact.xPhone : '',
					gmid: terminal.xGMID || '',
					gtid: terminal.xGTID || '',
					extendValue: atob(terminal.extendValue) || ''
				};
				this.generateBusinessInfoFile(fileData);
			},
			() => {
				this.notificationService.error('Failed to fetch business information.', 'Error');
			}
		);
	}

	// Byte offsets below map to fields of the _Credit_SetUp struct (#pragma pack(2)) in HSI_TYPS.HPP,
	// which defines the layout of assets/template/ccv_info.dat (49152 bytes).
	private readonly CCV_TEMPLATE_PATH = 'assets/template/ccv_info.dat';
	private readonly CCV_OFFSETS = {
		businessName: { offset: 40, maxLen: 21 },     // Business_Name_1 (new field)
		businessName2: { offset: 61, maxLen: 21 },     // Business_Name_2 (new field)
		businessAddress1: { offset: 82, maxLen: 31 },   // Business_Address_1
		businessAddress2: { offset: 113, maxLen: 31 },  // Business_Address_2
		businessCity: { offset: 144, maxLen: 22 },      // Business_City
		businessState: { offset: 166, maxLen: 3 },      // Business_State
		businessZip: { offset: 169, maxLen: 6 },     // Business_Zip (new field)
		businessPhone: { offset: 175, maxLen: 21 },   // Business_Phone
		businessEmail: { offset: 28752, maxLen: 36 },   // Business_Email		
		// businessZip: { offset: 33272, maxLen: 11 },     // Business_Zip (new field)
		// businessName: { offset: 33284, maxLen: 51 }     // Business_Name_1 (new field)
	};
	private readonly CCV_MAX_FPS = 15;                  // _MAX_FPS
	private readonly CCV_FP_AUTH_BASE = 240;            // FP_Auth_Data offset
	private readonly CCV_FP_AUTH_STRIDE = 378;          // sizeof(_Card_Proc_Rec)
	private readonly CCV_FP_AUTH_MERCHANT_REL = 64;     // _Card_Proc_Rec.Merchant_Id
	private readonly CCV_FP_AUTH_TERMINAL_REL = 85;     // _Card_Proc_Rec.Terminal_Id
	private readonly CCV_FP_AUTH_COMPANYID_REL = 148;     // _Card_Proc_Rec.Company_Id
	private readonly CCV_FP_SETTLE_BASE = 5910;         // FP_Settle_Data offset
	private readonly CCV_FP_SETTLE_STRIDE = 350;        // sizeof(_Card_Proc_Settle_Rec)
	private readonly CCV_FP_SETTLE_MERCHANT_REL = 2;    // _Card_Proc_Settle_Rec.Merchant_Id
	private readonly CCV_FP_SETTLE_TERMINAL_REL = 23;   // _Card_Proc_Settle_Rec.Terminal_Id
	private readonly CCV_FP_SETTLE_COMPANYID_REL = 86;     // _Card_Proc_Settle_Rec.Company_Id
	private readonly CCV_ID_FIELD_MAXLEN = 21;          // SZ_MERCHANT_ID/SZ_TERMINAL_ID + 1
	private readonly CCV_FP_AUTH_NETWORK_TYPE_REL = 62; // _Card_Proc_Rec.Network_Type
	private readonly CCV_FP_SETTLE_NETWORK_TYPE_REL = 0; // _Card_Proc_Settle_Rec.Network_Type
	private readonly CCV_NETWORK_TYPE_CLOUD9 = 0x36;    // NW_CLOUD9

	private generateBusinessInfoFile(fileData: any) {
		// console.log('fileData----->',fileData);
		this.http.get(this.CCV_TEMPLATE_PATH, { responseType: 'arraybuffer' }).subscribe(
			(buffer: ArrayBuffer) => {
				const bytes = new Uint8Array(buffer);

				this.writeFixedString(bytes, this.CCV_OFFSETS.businessName.offset, this.CCV_OFFSETS.businessName.maxLen, fileData.businessName);
				this.writeFixedString(bytes, this.CCV_OFFSETS.businessName2.offset, this.CCV_OFFSETS.businessName.maxLen, fileData.addrLine2);
				this.writeFixedString(bytes, this.CCV_OFFSETS.businessAddress1.offset, this.CCV_OFFSETS.businessAddress1.maxLen, fileData.addrLine1);
				this.writeFixedString(bytes, this.CCV_OFFSETS.businessAddress2.offset, this.CCV_OFFSETS.businessAddress2.maxLen, fileData.suite);
				this.writeFixedString(bytes, this.CCV_OFFSETS.businessCity.offset, this.CCV_OFFSETS.businessCity.maxLen, fileData.city);
				this.writeFixedString(bytes, this.CCV_OFFSETS.businessState.offset, this.CCV_OFFSETS.businessState.maxLen, fileData.state);
				this.writeFixedString(bytes, this.CCV_OFFSETS.businessZip.offset, this.CCV_OFFSETS.businessZip.maxLen, fileData.zip);
				this.writeFixedString(bytes, this.CCV_OFFSETS.businessEmail.offset, this.CCV_OFFSETS.businessEmail.maxLen, fileData.email);
				this.writeFixedString(bytes, this.CCV_OFFSETS.businessPhone.offset, this.CCV_OFFSETS.businessPhone.maxLen, fileData.phone);
				for (let i = 0; i < this.CCV_MAX_FPS; i++) {
					const authBase = this.CCV_FP_AUTH_BASE + i * this.CCV_FP_AUTH_STRIDE;
					bytes[authBase + this.CCV_FP_AUTH_NETWORK_TYPE_REL] = this.CCV_NETWORK_TYPE_CLOUD9;
					this.writeFixedString(bytes, authBase + this.CCV_FP_AUTH_MERCHANT_REL, this.CCV_ID_FIELD_MAXLEN, fileData.gmid);
					this.writeFixedString(bytes, authBase + this.CCV_FP_AUTH_TERMINAL_REL, this.CCV_ID_FIELD_MAXLEN, fileData.gtid);
					this.writeFixedString(bytes, authBase + this.CCV_FP_AUTH_COMPANYID_REL, this.CCV_ID_FIELD_MAXLEN, fileData.extendValue);

					const settleBase = this.CCV_FP_SETTLE_BASE + i * this.CCV_FP_SETTLE_STRIDE;
					bytes[settleBase + this.CCV_FP_SETTLE_NETWORK_TYPE_REL] = this.CCV_NETWORK_TYPE_CLOUD9;
					this.writeFixedString(bytes, settleBase + this.CCV_FP_SETTLE_MERCHANT_REL, this.CCV_ID_FIELD_MAXLEN, fileData.gmid);
					this.writeFixedString(bytes, settleBase + this.CCV_FP_SETTLE_TERMINAL_REL, this.CCV_ID_FIELD_MAXLEN, fileData.gtid);
					this.writeFixedString(bytes, settleBase + this.CCV_FP_SETTLE_COMPANYID_REL, this.CCV_ID_FIELD_MAXLEN, fileData.extendValue);
				}

				const blob = new Blob([bytes], { type: 'application/octet-stream' });
				const url = URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', 'ccv_info.dat');
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				URL.revokeObjectURL(url);
			},
			() => {
				this.notificationService.error('Failed to load the business info file template.', 'Error');
			}
		);
	}

	private writeFixedString(bytes: Uint8Array, offset: number, maxLen: number, value: string) {
		const str = (value || '').substring(0, maxLen - 1);
		for (let i = 0; i < maxLen; i++) {
			bytes[offset + i] = i < str.length ? (str.charCodeAt(i) & 0xFF) : 0;
		}
	}

	onShowDetails(obj: any) {
		this.showDetails = obj;
	}

	viewClosed(visible: boolean) {
		if (!visible) {
			this.terminalID = '';
			this.showDetails = false;
		}
	}
}
